/**
 * Homepage Block Components
 * Dynamic blocks for the Page Builder system
 */

export { default as HeroCarouselBlock } from './HeroCarouselBlock';
export { default as FeaturedSeriesBlock } from './FeaturedSeriesBlock';
export { default as TrendingBlock } from './TrendingBlock';
export { default as NewReleasesBlock } from './NewReleasesBlock';
export { default as GenreSpotlightBlock } from './GenreSpotlightBlock';
export { default as FeaturedCreatorsBlock } from './FeaturedCreatorsBlock';
export { default as FeaturedArtworksBlock } from './FeaturedArtworksBlock';
export { default as CTABannerBlock } from './CTABannerBlock';
export { default as NewsletterSignupBlock } from './NewsletterSignupBlock';

// Block type to component mapping
export const BLOCK_COMPONENTS = {
  HeroCarouselBlock: () => import('./HeroCarouselBlock'),
  FeaturedSeriesBlock: () => import('./FeaturedSeriesBlock'),
  TrendingBlock: () => import('./TrendingBlock'),
  NewReleasesBlock: () => import('./NewReleasesBlock'),
  GenreSpotlightBlock: () => import('./GenreSpotlightBlock'),
  FeaturedCreatorsBlock: () => import('./FeaturedCreatorsBlock'),
  FeaturedArtworksBlock: () => import('./FeaturedArtworksBlock'),
  CTABannerBlock: () => import('./CTABannerBlock'),
  NewsletterSignupBlock: () => import('./NewsletterSignupBlock'),
};
